
// Calculate age from DOB
export const calculateAge = (dob) => {
  if (!dob) {
    return "-"
  }
  const birthDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();

  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};


export function formatDate(date) {
  const d = new Date(date);

  const day = d.getDate().toString().padStart(2, '0');
  const month = d.toLocaleString('default', { month: 'short' }); // e.g., Apr
  const year = d.getFullYear();

  return `${day}-${month}-${year}`;
}

// Format a name (capitalize first letter)
export const formatName = (name) => {
  if (!name) return '';
  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
};

// Check if file is an image
export const isImageFile = (file) => {
  return file && file.type.startsWith('image/');
};

//   check gender
export const getGender = (genderCode) => {
  switch (genderCode) {
    case 1:
      return "Male";
    case 2:
      return "Female";
    case 3:
      return "Transgender";
    default:
      return "Unknown";
  }
};

//   alternate of gener
const vehicleMap = {
  2: "2-Wheeler",
  4: "4-Passenger",
  5: "5-Passenger",
  7: "7-Passenger",
};

export const getVehicleType = (vehicleCode) => {
  return vehicleMap[vehicleCode] || "Unknown";
};

// check status
export const getStatus = (stat) => {
  switch (stat) {
    case 0:
      return "Draft";
    case 1:
      return "Submitted";
    case 5:
      return "Approved";
    case 9:
      return "Rejected";
    default:
      return "Unknown";
  }
};

// user status
export const getUserStatus = (stat) => {
  switch (stat) {
    case 0:
      return "Pending Approval";
    case 1:
      return "Rejected";
    case 5:
      return "Approve";
    default:
      return "Unknown";
  }
};

// color code
export const getColor = (statusCode) => {
  switch (statusCode) {
    case 0:
      return 'yellow';
    case 5:
      return 'green';
    case 9:
      return 'red';
    default:
      return 'gray';
  }
};

// music code
export const getMusic = (mcode) => {
  switch (mcode) {
    case 0:
      return 'No Pref.';
    case 1:
      return 'English';
    case 2:
      return 'Hindi';
    case 3:
      return 'Local';
    default:
      return 'Not Required';
  }
};

export const extractCity = (components = []) => {
  const priority = [
    "locality",
    "administrative_area_level_3",
    "administrative_area_level_2",
    "sublocality",
    "postal_town",
    "neighborhood",
  ];

  for (const type of priority) {
    const match = components.find((comp) =>
      comp.types.includes(type)
    );

    if (match) {
      return match.long_name;
    }
  }

  return null;
};

export const moveDriverOnPolyline = ({
  path,
  interval = 2000,
  onUpdate,
  onComplete,
}) => {

  if (!path || path.length === 0) return;

  let index = 0;

  const timer = setInterval(() => {

    if (index >= path.length) {
      clearInterval(timer);

      if (onComplete) {
        onComplete();
      }

      return;
    }

    const point = path[index];

    //console.log("Polyline Point:", point);

    if (onUpdate) {
      onUpdate(point);
    }

    index++;

  }, interval);

  return () => clearInterval(timer);
};